// extracted by mini-css-extract-plugin
export default {"title":"aMra0WSscu","titleAndMoreInfoContainer":"BMPGF0qcNw"};